import React, { Component, PureComponent } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
    WithStyles,
    createStyles,
    Grid,
    Button,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@material-ui/core';
import { MyPATDialog, MyPATTextArea } from '.';
import contentService from '../mylibrary/services/contentService';
import LoaderComponent from './LoaderComponent';

const styles = (theme: Theme) => createStyles({
    overrideText: {
        textAlign: 'center',
        letterSpacing: '0.144385px',
        color: '#333333'
    },
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checkedIcon: {
        backgroundColor: 'rgb(29 125 234)',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },

    icon: {
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },

    infoContainer: {
        padding: '8px 0px',
        marginLeft: -10,
        marginRight: 16
    },

    graceCard: {
        padding: '34px 18px 33px',
        background: '#fff',
        borderRadius: 4
    },

    awardCard: {
        padding: '15px 18px 6px',
        background: '#fff',
        borderRadius: 4,
        '& >div': {
            color: '#333333'
        },
        '& textarea': {
            height: 60,
            width: "96%"
        }
    },

    whiteBox: {
        height: 65,
        background: 'rgb(255 255 255)',
        padding: '13px 12px'
    },

    widthSM: {
        maxWidth: 496,
        padding: '0px 54px 0px 40px'
    },

    widthMD: {
        maxWidth: 766
    },

    fontSM: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgb(51 51 51)',
        padding: 12
    },

    fontSizeSM: {
        fontSize: 12
    },

    marginTopSM: {
        marginTop: 12
    },

    graceTextField: {
        margin: '-4px 0px',
        '& input': {
            padding: '3px 0px 2px 6px',
            width: 80,
            height: 28,
            background: 'rgb(255 255 255)',
            border: '1px solid rgb(223 223 223)',
            borderRadius: 4
        },
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "block",
            height: 35,
            width: 18,
            padding: '0px 4px'
        }
    },

    labelText: {
        '& :nth-child(2)': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 16,
            lineHeight: '19px',
            color: '#333333',
            marginTop: 20
        }
    },

    marginTopMD: {
        margin: '8px 0px 0px',
    },

    marginBottom2x: {
        marginBottom: 16,
    },

    okButton: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '19px',
        letterSpacing: '0.5px',
        color: '#FFFFFF',
        background: '#1D7DEA',
        padding: '4px 22px',
        maxWidth: 150,
        borderRadius: 4,
        '&:hover': {
            background: '#1D7DEA'
        }
    },

    tableCell: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '18px',
        textAlign: 'center',
        color: 'rgb(51, 51, 51)'
    },
    borderNone: {
        border: 'none',
        height: 40
    },
    paddingSM: {
        padding: 0,
        minWidth: 130
    },
    tableRow: {
        height: 20
    },
    tableContainer: {
        height: 'auto',
        background: '#FCEEEE',
        border: '1px solid #E2E2E2',
        maxHeight: 400,
        overflowY: 'auto',
        borderRadius: 4,
        margin: '15px 0px',
        padding: '6px 0px 12px',
        width: 766,
        '& td': {
            borderBottom: '1px solid rgb(0 0 0 / 0%)',
            fontSize: 14,
            color: '#666666',
            padding: '4px 24px 4px 24px',
            whiteSpace: 'nowrap'
        }
    },
    noLabel: {
        marginTop: theme.spacing.unit * 3,
    },
    customTextarea: {
        paddingTop: "16px"
    }
});

export interface AddToQueueQuestionProps extends WithStyles<typeof styles> {
    type: string,
    subType: string,
    contentId: string,
    correctAnswer: any,
    alternateAnswer: boolean,
    setAlternateAnswer: Function
    changeHandler: Function,
    handleFormChange: Function,
    addToQueueCancel: any,
    addToQueueDone: any,
    eventFired: Function,
    history: any;
    updateContent: Function,
    matrixCorrectAnswer: any,
    matrixOptionContent: any,
    classes: any,
    isAlreadyInAddToQueue: boolean,
    alreadyInAddToQueueMsg: string,
}

interface AddToQueueQuestionState {
    showDialog: boolean,
    title: string,
    isAlternate: boolean,
    questionAttemps: any,
    republishQueue: string
}

class AddToQueueQuestion extends PureComponent<AddToQueueQuestionProps, AddToQueueQuestionState> {
    constructor(props: AddToQueueQuestionProps) {
        super(props);
        this.state = {
            showDialog: true,
            title: '',
            isAlternate: false,
            questionAttemps: {
                isLoading: false,
                data: []
            },
            republishQueue: ""
        }
    }

    componentDidMount() {
        const { contentId } = this.props;
        const { questionAttemps } = this.state;
        questionAttemps.isLoading = true
        this.setState({
            questionAttemps
        })
        contentService.getQuestionAttemps({ questionIds: [contentId] }).then((res: any) => {
            this.setState({
                questionAttemps: {
                    isLoading: false,
                    data: res.data
                }
            })
        });
    }
    handleRepublishQueueChange(event: any) {
        const { value } = event.target;
        this.setState({
            republishQueue: value
        })

    }
    addAwardCard(classes: any) {
        const { questionAttemps } = this.state;
        const { isAlreadyInAddToQueue, alreadyInAddToQueueMsg } = this.props;
        return (
            <>
                <Grid container alignItems="center" className={[classes.awardCard,
                classes.widthMD].join(' ')}>
                    <Grid justify="flex-start" alignItems="flex-start">This change will impact:</Grid>
                    <Grid className={classes.tableContainer}>
                        {
                            questionAttemps.isLoading ?
                                <LoaderComponent />
                                :
                                <Table>
                                    <TableHead>
                                        <TableRow classes={{ head: classes.tableRow }}>
                                            <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Test Name</TableCell>
                                            <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Test Id</TableCell>
                                            <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Students attempt</TableCell>
                                            <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Center</TableCell>
                                            <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Created By</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {questionAttemps.data.map((attemp: any, ) => {
                                            return <TableRow key={1} classes={{ root: classes.tableRow }}>
                                                <TableCell align="center">{attemp.name}</TableCell>
                                                <TableCell align="center">{attemp.contentId}</TableCell>
                                                <TableCell align="center">{attemp.finished}</TableCell>
                                                <TableCell align="center">{attemp.centre}</TableCell>
                                                <TableCell align="center">{attemp.createdBy}</TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                        }
                    </Grid>
                </Grid>
            </>
        )
    }

    render() {
        const {
            classes,
            isAlreadyInAddToQueue,
            alreadyInAddToQueueMsg
        } = this.props;
        const { showDialog, title, isAlternate } = this.state;
        return (
            <MyPATDialog
                dialogOpen={showDialog}
                dialogHasActions={true}
                dialogHeading={!isAlreadyInAddToQueue ? "Updated Option Summary" : " "}
                isAlignCenter={true}
                onDialogClose={this.props.addToQueueCancel}
                customButtonVariant="withoutBorderCloseIcon"
                isCustomBackground={!isAlreadyInAddToQueue}
                isborderDialogAction={isAlreadyInAddToQueue}
                otherDialogProps={{
                    fullWidth: false,
                    maxWidth: false
                }}
                customDialogActions={
                    <>
                        <Grid container justify="flex-end" alignItems="flex-end" className={isAlreadyInAddToQueue ? classes.marginBottom2x : ''}>
                            <Button onClick={this.props.addToQueueCancel} color="primary" className={classes.cancelButton}>Cancel</Button>

                            {isAlreadyInAddToQueue ?
                                <Button 
                                onClick={() => { 
                                    this.props.addToQueueDone({republishQueue: this.state.republishQueue, override: true});
                                    this.setState({showDialog: false}); 
                                 }} 
                                className={classes.okButton}>
                                    Ok
                                </Button> :
                                <Button onClick={() => { this.props.addToQueueDone({republishQueue: this.state.republishQueue, override: false})}} className={classes.okButton}>Add to Queue</Button>
                            }
                        </Grid>
                    </>
                }
            >
                {
                    isAlreadyInAddToQueue ?
                        <Grid container className={classes.widthSM}>
                            <Grid xs={12}>
                                <Typography variant="body1" align="center" classes={{ root: classes.overrideText }}>
                                    {alreadyInAddToQueueMsg}
                            </Typography>
                            </Grid>
                        </Grid>
                        :
                        <>
                            {this.addAwardCard(classes)}
                            <Grid container className={[(isAlternate ? classes.widthSM : classes.widthMD), classes.marginTopSM].join(' ')}>
                                <Grid xs={12}>
                                    <Typography variant="body1" className={[classes.fontSizeSM, (isAlternate && classes.whiteBox)].join(' ')}>
                                        <strong>Add to Queue:</strong> Add this changes to the Re-publish Queue to regenerate results for multiple Questions/Tests at once from MyLibrary Homepage
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.awardCard}>
                            <Grid justify="flex-start" alignItems="flex-start">Reason for Re-publish</Grid>
                            <MyPATTextArea
									inputId="republishReason"
									name="republishReason"
									placeholder="Enter reason here"
									onChange={this.handleRepublishQueueChange.bind(this)}
                                    value={this.state.republishQueue}
									multiline
                                    fullWidthControl
                                    className={classes.customTextarea}
								/>
                            </Grid>
                        </>
                }

            </MyPATDialog>
        );
    }
};

// @ts-ignore 
export default withStyles(styles)(AddToQueueQuestion);